<div fxLayout="row" fxLayoutAlign="center center">
    <!-- <div class="card-body"> -->
      <form
      autocomplete="off"
      name="resetPasswordForm"
      [formGroup]="vc_resetPasswordForm"
      fxFlex="100"
      fxFlex.gt-sm="50"
      fxLayout="column"
      (ngSubmit)="fn_resetPassword()"
      [mustMatch]="['iPassword', 'iConfirmPassword']"
    >
      <mat-form-field fxFlex fxFlexFill>
        <mat-label style="font-size: 16px; font-weight: 400">
          Contraseña actual</mat-label
        >
        <input
          matInput
          type="password"
          name="currentPassword"
          required
          [class.is-invalid]="
            (vc_resetPasswordForm.controls['iCurrentPassword'].touched ||
            vc_resetPasswordForm.controls['iCurrentPassword'].dirty) &&
            vc_resetPasswordForm.controls['iCurrentPassword'].invalid
          "
          [class.has-error]="
            (vc_resetPasswordForm.controls['iCurrentPassword'].touched ||
            vc_resetPasswordForm.controls['iCurrentPassword'].dirty) &&
            vc_resetPasswordForm.controls['iCurrentPassword'].invalid
          "
          formControlName="iCurrentPassword"
        />
      </mat-form-field>
      <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
        <mat-label style="font-size: 16px; font-weight: 400"
          >Contraseña</mat-label
        >
        <input
          type="password"
          name="password"
          matInput
          maxlength="16"
          matInput
          autocomplete="on"
          formControlName="iPassword"
          appPasswordPattern
          required
          [class.is-invalid]="
            (vc_resetPasswordForm.controls['iPassword'].touched ||
            vc_resetPasswordForm.controls['iPassword'].dirty) &&
            vc_resetPasswordForm.controls['iPassword'].invalid
          "
          [class.has-error]="
            (vc_resetPasswordForm.controls['iPassword'].touched ||
            vc_resetPasswordForm.controls['iPassword'].dirty) &&
            vc_resetPasswordForm.controls['iPassword'].invalid
          "
        />
      </mat-form-field>
  
      <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
        <mat-label style="font-size: 16px; font-weight: 400"
          >Confirmar Contraseña</mat-label
        >
        <input
          type="password"
          name="confirmPassword"
          matInput
          maxlength="16"
          matInput
          formControlName="iConfirmPassword"
          appPasswordPattern
          autocomplete="on"
          required
          [class.is-invalid]="
            (vc_resetPasswordForm.controls['iConfirmPassword'].touched ||
              vc_resetPasswordForm.controls['iConfirmPassword'].dirty) &&
            vc_resetPasswordForm.controls['iConfirmPassword'].invalid
          "
          [class.has-error]="
            (vc_resetPasswordForm.controls['iConfirmPassword'].touched ||
              vc_resetPasswordForm.controls['iConfirmPassword'].dirty) &&
            vc_resetPasswordForm.controls['iConfirmPassword'].invalid
          "
        />
  
        <mat-error
          *ngIf="
            vc_resetPasswordForm.controls['iConfirmPassword'].invalid &&
            vc_resetPasswordForm.controls['iConfirmPassword'].errors.mustMatch &&
            (vc_resetPasswordForm.controls['iConfirmPassword'].touched ||
              vc_resetPasswordForm.controls['iConfirmPassword'].dirty)
          "
        >
          Las contraseñas y la confirmación de contraseña deben coincidir
        </mat-error>
        <!-- Este campo es requerido -->
      </mat-form-field>
      <br />
      <button
        [disabled]="!vc_resetPasswordForm.valid || vc_passwordResetSuccess"
        mat-raised-button
        color="primary"
        type="submit"
        class="mt-16"
        style="
          font-size: large;
          font-weight: 400;
          padding-top: 2px;
          padding-bottom: 2px;
        "
      >
        Enviar
      </button>
    </form>

    <!-- <h2>Cambiar Contraseña</h2> -->
    <!-- <div class="card full-width">
      <div class="card-header">
        <h3>Cambiar Contraseña</h3>
      </div>
      
      </div>
    </div> -->
    
</div>
